/* Storefront theme: anti-spy protection layer (settings in Theme settings → Protection) */
(function () {
  'use strict';
  var C = window.SF && window.SF.protect;
  if (!C) return;
  var d = document;
  var blocked = false;

  function isField(t) {
    if (!t || !t.closest) return false;
    return !!t.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]');
  }

  /* ---------- Copy / save deterrents ---------- */
  if (C.copy) {
    d.addEventListener('contextmenu', function (e) { if (!isField(e.target)) e.preventDefault(); });
    d.addEventListener('dragstart', function (e) {
      var t = e.target;
      if (t && (t.tagName === 'IMG' || t.tagName === 'VIDEO' || t.tagName === 'A')) e.preventDefault();
    });
    d.addEventListener('selectstart', function (e) { if (!isField(e.target)) e.preventDefault(); });
    ['copy', 'cut'].forEach(function (ev) {
      d.addEventListener(ev, function (e) { if (!isField(e.target)) e.preventDefault(); });
    });
  }

  /* ---------- Keyboard shortcuts (save, source, print, devtools) ---------- */
  if (C.keys) {
    d.addEventListener('keydown', function (e) {
      var code = e.code || '';
      var key = (e.key || '').toLowerCase();
      var mod = e.ctrlKey || e.metaKey;
      var hit =
        key === 'f12' ||
        (mod && (code === 'KeyS' || code === 'KeyU' || code === 'KeyP')) ||
        (mod && e.shiftKey && (code === 'KeyI' || code === 'KeyJ' || code === 'KeyC' || code === 'KeyK')) ||
        (e.metaKey && e.altKey && (code === 'KeyI' || code === 'KeyJ' || code === 'KeyC' || code === 'KeyU'));
      if (hit) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* ---------- Spy extension detection ---------- */
  if (!C.ext) return;

  var words = String(C.words || '').split(',').map(function (w) { return w.trim(); }).filter(function (w) { return w.length > 2; });
  var re = words.length ? new RegExp(words.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|'), 'i') : null;
  var strict = C.level === 'strict';
  /* Extensions that commonly inject into pages and are harmless for shoppers */
  var allow = /grammarly|lastpass|bitwarden|1password|dashlane|honey|google-translate|goog-|translate|keeper|nordpass|adblock|ublock|darkreader|loom/i;

  function block() {
    if (blocked) return;
    blocked = true;
    try { if (observer) observer.disconnect(); } catch (e) {}
    try { window.stop(); } catch (e) {}
    var msg = C.msg || 'You can\'t view this page because of an extension in your browser. Please turn off your browser extensions and refresh the page.';
    var body = d.body || d.documentElement;
    Array.prototype.forEach.call(body.children, function (el) { el.style.setProperty('display', 'none', 'important'); });
    var wall = d.createElement('div');
    wall.className = 'sf-blocked';
    var card = d.createElement('div');
    card.className = 'sf-blocked__card';
    if (C.logo) {
      var logo = d.createElement('img');
      logo.className = 'sf-blocked__logo';
      logo.src = C.logo;
      logo.alt = 'Land Media';
      card.appendChild(logo);
    }
    var p = d.createElement('p');
    p.className = 'sf-blocked__msg';
    p.textContent = msg;
    card.appendChild(p);
    if (C.email) {
      var a = d.createElement('a');
      a.className = 'sf-blocked__mail';
      a.href = 'mailto:' + C.email + '?subject=' + encodeURIComponent('Product hunting services');
      a.textContent = C.email;
      card.appendChild(a);
    }
    // Optional: send the visitor to another website after a short countdown
    var go = C.redirect && /^https?:\/\//i.test(C.redirect) ? C.redirect : null;
    if (go) {
      var secs = Math.max(1, parseInt(C.delay, 10) || 5);
      var note = d.createElement('p');
      note.className = 'sf-blocked__note';
      var tick = function () { note.textContent = 'Redirecting in ' + secs + 's…'; };
      tick();
      card.appendChild(note);
      var cd = setInterval(function () {
        secs -= 1;
        if (secs <= 0) { clearInterval(cd); location.replace(go); return; }
        tick();
      }, 1000);
    }
    wall.appendChild(card);
    body.appendChild(wall);
    // Keep the page empty even if the extension re-injects content
    d.title = '';
    setInterval(function () {
      Array.prototype.forEach.call(body.children, function (el) {
        if (el !== wall) el.style.setProperty('display', 'none', 'important');
      });
    }, 800);
  }

  function signature(el) {
    var s = (el.tagName || '') + ' ' + (el.id || '');
    var cls = el.getAttribute && el.getAttribute('class');
    if (cls) s += ' ' + cls;
    ['src', 'href', 'data-extension', 'data-id', 'name'].forEach(function (a) {
      var v = el.getAttribute && el.getAttribute(a);
      if (v) s += ' ' + v;
    });
    return s;
  }

  function hasExtUrl(s) { return /(chrome|moz|safari-web|ms-browser)-extension:\/\//i.test(s); }

  function check(el) {
    if (blocked || !el || el.nodeType !== 1) return;
    if (el.classList && el.classList.contains('sf-blocked')) return;
    var sig = signature(el);
    if (re && re.test(sig)) return block();
    if (el.shadowRoot && re && re.test(el.shadowRoot.innerHTML.slice(0, 4000))) return block();
    if (strict && hasExtUrl(sig) && !allow.test(sig)) return block();
    // Look one level into injected wrappers (extensions usually inject a small root)
    var kids = el.children;
    if (kids && kids.length && kids.length < 60) {
      for (var i = 0; i < kids.length; i++) {
        var ks = signature(kids[i]);
        if (re && re.test(ks)) return block();
        if (strict && hasExtUrl(ks) && !allow.test(ks)) return block();
      }
    }
  }

  function scanTopLevel() {
    if (blocked) return;
    var roots = [d.documentElement];
    if (d.body) roots.push(d.body);
    roots.forEach(function (r) { Array.prototype.forEach.call(r.children, check); });
    // Extension stylesheets / scripts injected into the page
    Array.prototype.forEach.call(d.querySelectorAll('link[href*="-extension://"], script[src*="-extension://"], iframe[src*="-extension://"], img[src*="-extension://"]'), function (el) {
      var sig = signature(el);
      if ((re && re.test(sig)) || (strict && !allow.test(sig))) block();
    });
  }

  var observer = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length && !blocked; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length && !blocked; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        // Only nodes injected outside the theme's own containers are suspicious
        if (n.closest && n.closest('#main, .header-wrap, .footer, .shopify-section')) continue;
        check(n);
      }
    }
  });
  observer.observe(d.documentElement, { childList: true, subtree: true });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', scanTopLevel);
  else scanTopLevel();
  window.addEventListener('load', scanTopLevel);
  setTimeout(scanTopLevel, 2500);
  setTimeout(scanTopLevel, 6000);

  /* ---------- Known extension resource probes (advanced) ---------- */
  String(C.probes || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean).forEach(function (url) {
    if (!hasExtUrl(url)) return;
    var img = new Image();
    img.onload = block;
    img.src = url;
    if (window.fetch) {
      try { fetch(url).then(function (r) { if (r.ok) block(); }).catch(function () {}); } catch (e) {}
    }
  });
})();
